export default __webpack_public_path__ + "static/media/gift.e7da220c.gif";